import { FORTA_GRAY3, FORTA_GRAY4 } from '../../../../../utils/colors';

export const RECOUPMENT_SELECT_SX = {
  boxShadow: 'none',
  borderRadius: '8px',
  '& input::placeholder': { fontSize: '14px', color: FORTA_GRAY4 },
  '&.Mui-disabled': {
    WebkitTextFillColor: FORTA_GRAY3,
    cursor: 'not-allowed',
  },
};
